module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/mineteria.647d5193.png";